import type { MenuGroup, NavLinkConfig } from '../../providers/routes-provider.types';

/**
 * Grupurile din sidebar — partea PURA a `AppSidebar` (etichete, ordine, grupare, ce grupuri se afiseaza), ca sa
 * fie testabila in vitest (mediu `node`, fara montare de componente).
 *
 * 🔴 Eticheta «Instrumente Admin» apartine doar rutelor de administrare. Un ELEV sau un PROFESOR nu trebuie sa o
 * vada: formularele si mesageria lor stau in `formulare` / `comunicare` (`menu-groups.test.ts` pazeste, pe sursa
 * providerului, ca nicio ruta permisa lor nu are `menuGroup: 'admin'`).
 */
export const GROUP_LABELS: Record<MenuGroup, string> = {
  activities: 'Activități',
  waste: 'Colectare Deșeuri',
  users: 'Utilizatori',
  comunicare: 'Comunicare',
  formulare: 'Formulare',
  admin: 'Instrumente Admin',
};

export const GROUP_ORDER: MenuGroup[] = ['activities', 'waste', 'users', 'comunicare', 'formulare', 'admin'];

export function groupLinksByMenuGroup(links: NavLinkConfig[]): Record<MenuGroup, NavLinkConfig[]> {
  const grouped = Object.fromEntries(GROUP_ORDER.map((g) => [g, [] as NavLinkConfig[]])) as Record<
    MenuGroup,
    NavLinkConfig[]
  >;

  links.forEach((link) => {
    if (link.menuGroup) {
      grouped[link.menuGroup].push(link);
    }
  });

  return grouped;
}

/**
 * Grupurile care se afiseaza, in ordine: doar cele nevide. Separatorul se pune intre oricare doua grupuri
 * afisate consecutiv — inainte se punea doar daca urmatorul grup din `GROUP_ORDER` era nevid, deci un elev cu
 * «Activități» + «Comunicare» (cu `waste`/`users` goale intre ele) nu avea separator.
 */
export function grupuriDeAfisat(grouped: Record<MenuGroup, NavLinkConfig[]>): MenuGroup[] {
  return GROUP_ORDER.filter((g) => grouped[g].length > 0);
}
